import React from "react";
import { TablePagination, createTheme, ThemeProvider, } from "@mui/material";
// import Pagination from '@mui/material/Pagination';
// import { createTheme, ThemeProvider } from '@mui/material/styles';
import { frFR } from '@mui/material/locale';
import { useTailwindBrand } from "../shared";



interface PaginationProps {
  onPageChange?: ((page: number) => void) | any;
  pageLimit?: ((limitNumber: number) => void) | any
  items?: number
  currentPage?: number
  isDeclare?: boolean
}

export default function Pagination(props: PaginationProps) {
  const { onPageChange, pageLimit, items, currentPage, isDeclare } = props
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const { classes, brandConfig } = useTailwindBrand()

  const theme = createTheme(
    {
      palette: {
        primary: { main: '#1976d2' },
      },
      typography: {
        fontFamily: brandConfig.fontFamily, // optionnel mais recommandé
      },
      components: {
        MuiTablePagination: {
          styleOverrides: {
            root: {
              fontFamily: brandConfig.fontFamily,
            },
            toolbar: {
              fontFamily: brandConfig.fontFamily,
            },
            selectLabel: {
              fontFamily: brandConfig.fontFamily,
            },
            input: {
              fontFamily: brandConfig.fontFamily,
            },
            displayedRows: {
              fontFamily: brandConfig.fontFamily,
            },
          },
        },
      },
    },
    frFR,
  );
  
  const handleChangePage = (event: React.MouseEvent<HTMLButtonElement> | null, newPage: number,) => {
    setPage(newPage);
    onPageChange(newPage);
  };

  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,) => {
    const newRowsPerPage = parseInt(event.target.value, 10);
    setRowsPerPage(newRowsPerPage);
    pageLimit(newRowsPerPage);
    setPage(0);
  };


  return (
    <ThemeProvider theme={theme}>
      <TablePagination
        component="div"
        count={items ?? 0}
        page={currentPage ?? page}
        onPageChange={handleChangePage}
        rowsPerPage={rowsPerPage}
        onRowsPerPageChange={handleChangeRowsPerPage}
        sx={{ fontFamily: brandConfig.fontFamily }}
        rowsPerPageOptions={isDeclare ? [] : [5, 10, 25, 50, 100]} // Hides rowsPerPageOptions
      />
    </ThemeProvider>
  );
}
